var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-snackbar",
        {
          attrs: {
            outlined: "",
            absolute: "",
            top: "",
            dismissible: "",
            color: "error"
          },
          scopedSlots: _vm._u([
            {
              key: "action",
              fn: function({ attrs }) {
                return [
                  _c(
                    "v-btn",
                    _vm._b(
                      {
                        attrs: { color: "red", text: "" },
                        on: {
                          click: function($event) {
                            _vm.orderDetailStatusPostErrors = []
                          }
                        }
                      },
                      "v-btn",
                      attrs,
                      false
                    ),
                    [_c("span", [_vm._v("Close")])]
                  )
                ]
              }
            }
          ]),
          model: {
            value: _vm.orderDetailStatusPostErrors.errors,
            callback: function($$v) {
              _vm.$set(_vm.orderDetailStatusPostErrors, "errors", $$v)
            },
            expression: "orderDetailStatusPostErrors.errors"
          }
        },
        [
          _vm.orderDetailStatusPostErrors.errors
            ? _c(
                "div",
                [
                  _c("v-icon", { staticClass: "error--text mr-2" }, [
                    _vm._v("mdi-alert")
                  ]),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.orderDetailStatusPostErrors.errors.first())
                    )
                  ])
                ],
                1
              )
            : _vm._e()
        ]
      ),
      _c(
        "v-toolbar",
        { attrs: { color: "primary", dark: "", dense: "", elevation: "0" } },
        [_c("span", [_vm._v("New Status")])]
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "ID",
                  "error-messages": _vm.orderDetailStatusPostErrors.id || []
                },
                model: {
                  value: _vm.id,
                  callback: function($$v) {
                    _vm.id = $$v
                  },
                  expression: "id"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Name",
                  "error-messages": _vm.orderDetailStatusPostErrors.name || []
                },
                model: {
                  value: _vm.name,
                  callback: function($$v) {
                    _vm.name = $$v
                  },
                  expression: "name"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "green",
                    dark: "",
                    tile: "",
                    loading: _vm.orderDetailStatusPosting
                  },
                  on: { click: _vm.storeOrderDetailStatus }
                },
                [_c("span", [_vm._v("Save")])]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }